"use client";

import type * as React from "react";
import { SegmentedProgressBar } from "@/components/ui/segmented-progress-bar";
import { STAKE_CONSTANTS } from "@/lib/stake/stake-constants";

interface Remaining {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

interface DaoYearProgressBarProps {
  remaining: Remaining;
}

const YEAR_SECONDS = Number(STAKE_CONSTANTS.REWARD_DECAY_PERIOD_SECONDS); // 31_536_000

/** Elapsed fraction of the current DAO year, as the site's segmented bar. */
export const DaoYearProgressBar: React.FC<DaoYearProgressBarProps> = ({
  remaining,
}) => {
  const remainingSec =
    remaining.days * 86400 +
    remaining.hours * 3600 +
    remaining.minutes * 60 +
    remaining.seconds;
  const elapsedPct = Math.min(
    100,
    Math.max(0, (1 - remainingSec / YEAR_SECONDS) * 100),
  );
  return <SegmentedProgressBar value={elapsedPct} />;
};
